import {images} from './images'
import {MetaTagsProps, BlogCategory, BlogCategoryDetails} from "@/types";
import EmojiEventsIcon from "@mui/icons-material/EmojiEvents";
import {blog as blog1, createMetaTags as tags1} from "@/content/blogs/1/1";
import {OG_PATH, WEBSITE_URL} from "@/content";

export const blogCategory: BlogCategory = {
    id: 1,
    key: 'HeadBlogCategory1Key',
    name: 'HeadBlogCategory1Name',
    long_name: 'HeadBlogCategory1LongName',
    slug: 'head-blog-category-1-slug',
    categoryType: 'blogs',
}


export const metaTags: MetaTagsProps = {
    title: "MetaHeadBlogCategory1Title",
    description: "MetaHeadBlogCategory1Description",
    keywords: "MetaHeadBlogCategory1Keywords",
    url: `${WEBSITE_URL}/${blogCategory.categoryType}/${blogCategory.slug}`,
    ogImage: `${OG_PATH}img1.jpg`,
    type: "website",
}

export const blogsObject = Object.fromEntries(
    Object.entries({
        blog1: {...blog1, ...tags1(metaTags)},
    }).map(([key, value]) => [key, {...value, blogCategory}])
);

const blogs = Object.values(blogsObject);

export const blogCategoryDetails: BlogCategoryDetails = {
    ...blogCategory,
    order: 1,
    icon: <EmojiEventsIcon/>,
    description: ['HeadBlogCategory1Description'],
    points: [],
    videos: [],
    metaTags,
    images,
    blogs
}


